// extracted by mini-css-extract-plugin
export default {"container":"AccountSignupFormV2--container--FxAKe"};